import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { SHOW_DISCLAIMER_EVENT } from './DisclaimerDialog';

/** Slim footer that keeps the safety/AI disclaimer one click away on every page. */
const AppFooter: React.FC = () => (
  <Box component="footer" sx={{ textAlign: 'center', px: 2, pt: 1, pb: 10 }}>
    <Typography variant="caption" color="text.secondary">
      Diving carries inherent risks; nothing here replaces training, an instructor, or your own judgment. Nereus is an AI that can be wrong.{' '}
      <Link
        component="button"
        type="button"
        variant="caption"
        onClick={() => window.dispatchEvent(new Event(SHOW_DISCLAIMER_EVENT))}
        sx={{ verticalAlign: 'baseline' }}
      >
        Safety &amp; AI disclaimer
      </Link>
    </Typography>
  </Box>
);

export default AppFooter;
